import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { StorageDexieService } from '../services/storage.dexie.service';
import { FlowEventService } from '../services/flow-event.service';
import { FlowManagementService } from '../services/flow-management.service';

@Component({
    selector: 'app-plan-edit',
    templateUrl: './plan-edit.component.html',
    styleUrls: ['./plan-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlanEditComponent implements OnInit {

  editorOptions = { /*theme: 'vs-dark',*/ language: 'json', automaticLayout: true };
  code: string = '';

  @Input() editorType: string;
  @Input() plans: any = null;
  @Input() plan: any = null;
  // flowData: any;
  id: string = null;
  editor = null;
  error: string;
  ready = false;

  /** True when this component was reached through a route (`/migrate/plan` or
   *  `/migrate/plan/:id`) rather than being projected as a tab via inputs.
   *  Drives close() — route mode navigates back to /migrate; tab mode emits
   *  the legacy closeTabWindow$ event for the tab-strip to remove. */
  private routedPage = false;

  constructor(
    // private flowStorageDexieService: StorageDexieService,
    private flowManagemnetService: FlowManagementService,
    private flowEventService: FlowEventService,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  async ngOnInit() {
    this.ready = false;

    // Route mode — `/migrate/plan` or `/migrate/plan/:id`. Detect by paramMap;
    // when a route param is present we're hosted as a page, not a tab.
    const id = this.route.snapshot.paramMap.get('id');
    const isRouted = !!this.route.snapshot.routeConfig?.path?.startsWith('migrate/plan');

    if (isRouted) {
      this.routedPage = true;
      try {
        const plans = await this.flowManagemnetService.getPlans();
        if (id) {
          // Single-plan view — find by name (the plan's identifier).
          const plan = (plans || []).find((p: any) => p?.name === id) || null;
          this.plan = plan;
          if (plan) {
            this.code = JSON.stringify(plan, null, 2);
            this.id = plan.name;
          } else {
            this.error = `Plan "${id}" not found.`;
          }
        } else {
          // All-plans editor — full list as JSON.
          this.plans = plans;
          this.code = JSON.stringify(plans, null, 2);
        }
      } catch (err: any) {
        this.error = err?.message || String(err);
      }
      this.ready = true;
      return;
    }

    // Legacy tab/popup mode — the parent passed `[plans]` or `[plan]` as input.
    if (this.plans) {
      this.flowManagemnetService.getPlans().then(plans => {
        this.plans = plans;
        this.code = JSON.stringify(this.plans, null, 2);
        this.ready = true;
      })
    }
    if (this.plan) {
      this.code = JSON.stringify(this.plan, null, 2);
      this.id = this.plan.name;
      this.ready = true;
    }
  }

  onInit(editor) {
    //let line = editor.getPosition();
    //console.log(line);
    this.editor = editor;
    // this.editor.setValue(this._code);
    // this.editor.layout();
    //debugger
  }

  public onSaveClick(): void {
    // console.log("on click");

    // if (this.plans) {

    try {
      this.ready = false;

      if (this.plans) {
        let plans = JSON.parse(this.code);

        this.flowManagemnetService.updatePlans(plans).then(()=>{
  
          this.flowEventService.planUpdated$.next(true);
          this.ready = true;
        });  
      }
      if (this.plan) {
        let plan1 = JSON.parse(this.code);

        this.flowManagemnetService.getPlans().then(plans => {

          for(let i=0; i< plans.length; i++){
            if (plans[i].name == this.id) {
              plans[i] = plan1;
            }
          };
          return plans;
        }).then((plans)=>{
          return this.flowManagemnetService.updatePlans(plans);
        }).then(()=>{
          this.flowEventService.planUpdated$.next(true);
          this.ready = true;
        });

      }

    }
    catch (err) {
      this.error = err;
      this.ready = true;
    }
    // }

  }

  close() {
    // Route mode — back to /migrate. The component is just a route landing,
    // no tab to close.
    if (this.routedPage) {
      this.router.navigate(['/migrate']);
      return;
    }

    // Legacy tab/popup mode — drop the tab from the strip.
    if (this.plans) {
      this.flowEventService.closeTabWindow$.emit({
        value: false,
        type: "app-plan-edit"
      });
    }
    if (this.plan) {
      this.flowEventService.closeTabWindow$.emit({
        id: this.id,
        value: false,
        type: "app-plan"
      });
    }
  }

}
